var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page",style:({ 'background-color': _vm.page.backgroundColor.value })},[_c('div',{staticClass:"m-pc-page"},[_c('Header')],1),_c('Banner'),_c('div',{staticClass:"m-pc-page page-bottom"},[_c('List')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }